import { gql } from '@apollo/client'

export const generateBlogSummaryMutation = gql`
  mutation generateBlogSummary($input: GenerateBlogSummaryArgs!) {
    generateBlogSummary(input: $input)
  }
`
